import logger from '@/utils/logger';
import {
  buildOptions,
  getEndPoints
} from '../../../utils/api-call';
import {
  makeCall
} from '../../../utils/request';
import {
  FETCH_API_VERSION
} from './constants';
import localStorageKeys from '../../local-storage-keys';

export const state = {
  users: {}
};

export const actions = {
  [FETCH_API_VERSION] ({ commit }) {
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().users.apiVersion,
        buildOptions('GET', undefined, undefined, { skipAuthen: true }),
        commit
      )
        .then(response => {
          resolve(response);
        }, error => {
          logger.error('error=', error);
          reject(error);
        });
    });
  }
};

export const getters = {
  getUserInfo: () => JSON.parse(localStorage.getItem(localStorageKeys.USER)),
  isLoggedIn: () => localStorage.getItem(localStorageKeys.TOKEN) && localStorage.getItem(localStorageKeys.TOKEN).length > 0 ? localStorage.getItem(localStorageKeys.TOKEN) : ''
};

export const mutations = {
};

export default {
  state,
  actions,
  getters,
  mutations
};
